import { render, staticRenderFns } from "./chatInfo.vue?vue&type=template&id=603a0991&scoped=true"
import script from "./chatInfo.vue?vue&type=script&lang=ts"
export * from "./chatInfo.vue?vue&type=script&lang=ts"
import style0 from "./chatInfo.vue?vue&type=style&index=0&id=603a0991&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603a0991",
  null
  
)

export default component.exports